import { translate } from "../../../../utils/Common";

const TipsForDropOff = () => {
    return (
        <div className="flex flex-wrap -mx-2 text-center mx-2">
            <div className="w-12/12 md:w-4/12 p-2">
                <div className="dashboardCard m-0 h-full flex items-center">
                    <p className="m-0">{translate("dashboard.packages.dropOff.tipsForDropOff.descripNumPackage")} <span className="font-semibold">{translate("global.numPackage")} </span>
                        {translate("dashboard.packages.dropOff.tipsForDropOff.sealed")}
                    </p>
                </div>
            </div>
            
            <div className="w-12/12 md:w-4/12 p-2">
                <div className="dashboardCard m-0 h-full flex items-center">
                    <p className="m-0">
                        {translate("dashboard.packages.dropOff.tipsForDropOff.the")} <span className="font-semibold">{translate("global.numIdentity")} </span>
                        {translate("dashboard.packages.dropOff.tipsForDropOff.timeRegistration")}
                    </p>
                </div>
            </div>
            
            <div className="w-12/12 md:w-4/12 p-2">
                <div className="dashboardCard m-0 h-full flex items-center">
                    <p className="m-0">
                        {translate("global.to")} <span className="font-semibold">{translate("dashboard.packages.dropOff.tipsForDropOff.scanCode")} </span>
                        {translate("dashboard.packages.dropOff.tipsForDropOff.descripCamera")}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default TipsForDropOff;